import React, { Component } from 'react';
import { Box, Link, Typography } from '@mui/material';
import Footercontent from './footercontent';

class Footer extends Component {
    render() {
        // const navigate = useNavigate();
        return (
            <Box>
                <Box>
                    <Typography>
                        <Footercontent />
                    </Typography>
                </Box>
            </Box>
        );
    }
}
export default Footer;